import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import { Row,Col, Card, Form, Button } from 'react-bootstrap';
import {Helmet} from "react-helmet";
import {
  getls, integerIndMobile, lettersOnly, integerAadhar, integerKeyPress, decimalKeyPress, upperCase
} from '../../../utils';
import {Api} from '../../../utils/Variables';
import axios from 'axios';
import { message, Tooltip, Spin,}  from 'antd';

import PsContext from '../../context/PsContext';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 8 },
};

class AddCustomer extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			showLoader: false,
		}
		
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		
	}
	
	componentDidMount(){
		
		this.context.updateHeader({
			top: false,
			title: 'New Customer',
			back: true,
		});
		
	}
	
	componentWillUnmount(){
		
		this.context.updateHeader({top: false});		
	}
	
	
	handleFormSubmit(e){
		e.preventDefault();
		try{
			this.setState({showLoader: true});
			 axios.post(Api.Url+'v1/customer/new', $("#frmAddCustomer").serialize()).then(res=>{
				if(res['data'].status=='1'){
					document.getElementById("frmAddCustomer").reset();
					message.success(res['data'].message || 'Success');
					this.setState({showLoader: false});
				}	
				else{
					message.error(res['data'].message || 'Error');
					this.setState({showLoader: false});
				}
			 });
			
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	render(){

		return(
			<div className="container" >
			<div data-aos="fade" >
				
				<Spin spinning={this.state.showLoader} >
				
				<div className="card user-data-card">
					<div className="card-body">
						<form
							action=""
							method="post"
							encType="multipart/form-data"
							id="frmAddCustomer"
							onSubmit={this.handleFormSubmit}
						>
						
						<input type="hidden" name="api" value={this.context.state.api} />
						
						<Form.Group>
							<label>
								<span className="text-danger">* </span>
								Name
							</label>
							<Form.Control
								type="text"
								name="i__name"
								size="sm"
								required
							/>
						</Form.Group>
						
						<Form.Group className="mt-10" >
							<label>
								<span className="text-danger">* </span>
								Code
							</label>
							<Form.Control
								type="number"
								name="i__code"
								size="sm"
								required
							/>
						</Form.Group>
						
						<Form.Group className="mt-10" >
							<label>
								<span className="text-danger"> </span>
								Place
							</label>
							<Form.Control
								type="text"
								name="i__place"
								size="sm"
							/>
						</Form.Group>
						
						<Form.Group className="mt-10" >
							<label>
								<span className="text-danger"> </span>
								Mobile
							</label>
							<Form.Control
								type="number"
								name="i__mobile"
								size="sm"
							/>
						</Form.Group>
						
						<Form.Group className="mt-10" >
							<label>
								<span className="text-danger"> </span>
								Bank Account No
							</label>
							<Form.Control
								type="text"
								name="i__accountNo"
								size="sm"
							/>
						</Form.Group>
						
						<Row className="mt-30" >
							<Col md={12} >
								<Button
									type="submit"
									variant="success"
									size="md"
									block
									style={{width: '100%'}}
								>
									Save Customer
								</Button>
							</Col>
						</Row>
							
						</form>
					</div>
				  </div>
				
				</Spin>
				 
			</div>
			</div>
		);
	}
	
}
export default AddCustomer;
